import { sign } from 'node:crypto';

export const AmplitudeEvents = {
  // Main links clicked
  home_app_clicked: 'Home Page Clicked',
  categories_clicked: 'Categories Viewed',
  cart_clicked: 'Cart Viewed',
  my_account_clicked: 'Profile Viewed',
  search_bar_clicked: 'Search Bar Clicked',
  stores_clicked: 'Shops List Opened',
  join_us: 'Join Us Viewed',
  my_wishlist_clicked: 'Wishlist Viewed',
  signed_out: 'Signed Out',
  signed_in: 'Signed In',
  search_performed: 'Search Performed',

  // Account Screen
  edit_account_clicked: 'Profile Viewed',
  my_orders_clicked: 'Orders Viewed',
  favorites_clicked: 'Wishlist Viewed',
  coupons_clicked: 'Coupons Viewed',
  coupon_code_copied: 'Coupon Code Copied',
  profile_updated: 'Profile Updated',
  wallet_clicked: 'Wallet Viewed',
  shipments_viewed: 'Shipments Viewed',
  my_addresses_clicked: 'Addresses Viewed',
  new_address_added: 'New Address Added',
  payments_viewed: 'Payments Viewed',
  card_deleted: 'Card Deleted',
  new_card_added: 'New Card Added',
  my_saved_cards_clicked: 'Payments Viewed',
  change_language_clicked: 'Language Changed',
  about_pik_clicked: 'About Pik Viewed',
  contact_us_clicked: 'Contact Us Viewed',
  settings_clicked: 'Settings Viewed',
  choose_language_clicked: 'Language Changed',
  privacy_policy_clicked: 'Privacy Policy Viewed',
  terms_and_conditions_clicked: 'Terms and Conditions Viewed',
  prime_clicked: 'Prime Viewed',
  reported_issues_clicked: 'Reported Issues Clicked',

  // Single pages
  store_clicked: 'Shop Viewed',

  // Store Screen
  search_performed_in_shop: 'Search Performed in Shop',
  search_performed_in_shops: 'Search Performed in Shops',
  branch_changed: 'Branch Changed',
  about_shop_viewed: 'About Shop Viewed',
  store_added_to_favorite: 'Shop Favorited',
  store_removed_from_favorite: 'Shop Unfavorited',
  filter_clicked: 'Filter by Industry',
  store_industry_clicked: 'Filter by Industry',
  store_subindustry_clicked: 'Filter by Industry',
  store_more_info_clicked: 'Store More Info Clicked',

  // Product Screen
  product_clicked: 'Product Viewed',
  product_added_to_favorite: 'Product Favorited',
  product_removed_from_favorite: 'Product Unfavorited',
  cart_icon_clicked: 'Carts Viewed',
  product_added_to_cart: 'Product Added to Cart',
  product_added_to_cart_clicked: 'Product Added to Cart Clicked',
  product_removed_from_cart: 'Product Removed from Cart',
  product_quantity_increased: 'Quantity Increased',
  product_quantity_decreased: 'Quantity Decreased',
  product_picture_clicked: 'Product Picture Clicked',

  // Checkout Screen
  checkout_started: 'Checkout Started',
  gift_checkout_started: 'Gift Checkout Started',
  order_type_clicked: 'Delivery Type Changed',
  address_changed: 'Address Changed',
  change_payment_method: 'Payment Method Selected',
  payment_failed: 'Payment Failed',
  order_created: 'Order Created (API)',
  pay_order_clicked: 'Pay Order Clicked',
  order_creation_failed: 'Order Creation Failed (API)',
  apply_coupon_code_clicked: 'Coupon Applied',
  use_wallet_balance_clicked: 'Wallet Balance Viewed',

  // Order Details
  order_cancellation_initiated: 'Order Cancellation Initiated',
  order_cancelled: 'Order Cancelled',
  reorder_initiated: 'Reorder Initiated',
  issue_request_initiated: 'Issue Request Initiated',
  issue_request_submitted: 'Issue Request Submitted',

  // Page View
  page_viewed: 'page viewed',
} as const;

export type AmplitudeEventProperties = {
  // Main links clicked
  [AmplitudeEvents.home_app_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.categories_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.cart_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.my_account_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.search_bar_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.stores_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.join_us]: { userId?: string; environment?: string };
  [AmplitudeEvents.my_wishlist_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.search_performed]: {
    userId?: string;
    search_keyword: string;
    environment?: string;
  };

  // Account Screen
  [AmplitudeEvents.edit_account_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.my_orders_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.favorites_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.wallet_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.my_addresses_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.my_saved_cards_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.change_language_clicked]: {
    language: 'ar' | 'en';
    userId?: string;
    environment?: string;
  };
  [AmplitudeEvents.about_pik_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.contact_us_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.settings_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.privacy_policy_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.terms_and_conditions_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.prime_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.reported_issues_clicked]: { userId?: string; environment?: string };
  [AmplitudeEvents.signed_out]: { userId?: string; environment?: string };
  [AmplitudeEvents.signed_in]: { userId?: string; environment?: string };
  [AmplitudeEvents.new_card_added]: { userId?: string; environment?: string };
  [AmplitudeEvents.card_deleted]: { userId?: string; environment?: string };
  [AmplitudeEvents.profile_updated]: { userId?: string; environment?: string };

  // Single pages

  // shop Screen
  [AmplitudeEvents.store_clicked]: {
    shop_id: number;
    shop_name: string;
    // environment?: string;
  };

  [AmplitudeEvents.search_performed_in_shop]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
    search_keyword: string;
    environment?: string;
  };

  [AmplitudeEvents.about_shop_viewed]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
  };

  [AmplitudeEvents.branch_changed]: {
    shop_id: number;
    shop_name: string;
    old_branch_id: number;
    old_branch_name: string;
    new_branch_id: number;
    new_branch_name: string;
    environment?: string;
  };
  [AmplitudeEvents.store_added_to_favorite]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
    branch_id: number;
    branch_name: string;
    environment?: string;
  };
  [AmplitudeEvents.store_removed_from_favorite]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
    branch_id: number;
    branch_name: string;
    environment?: string;
  };
  // [AmplitudeEvents.filter_clicked]: {
  //   shop_id: number; // Store ID
  //   shop_name: string; // Store Name
  //   branch_id: number;
  //   branch_name: string;
  //   environment?: string;
  // };
  [AmplitudeEvents.store_industry_clicked]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
    branch_id: number;
    branch_name: string;
    industry_id: number;
    industry_name: string;
    environment?: string;
  };
  // [AmplitudeEvents.store_subindustry_clicked]: {
  //   shop_id: number; // Store ID
  //   shop_name: string; // Store Name
  //   branch_id: number;
  //   branch_name: string;
  //   sub_industry_id: number;
  //   sub_industry_name: string;
  //   environment?: string;
  // };
  [AmplitudeEvents.store_more_info_clicked]: {
    shop_id: number; // Store ID
    shop_name: string; // Store Name
    branch_id: number;
    branch_name: string;
    environment?: string;
  };
  [AmplitudeEvents.search_performed_in_shops]: {
    search_keyword: string;
    environment?: string;
  };
  /***************************************** */
  // Product Screen
  [AmplitudeEvents.product_clicked]: {
    shop_id: number;
    shop_name: string;
    branch_id: number | string;
    branch_name: string | null;
    product_id: string;
    product_name: string | null;
    industry_id: number | null;
    industry_name: string | null;
    has_discount: boolean;
    environment?: string;
  };
  [AmplitudeEvents.product_added_to_favorite]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
    environment?: string;
  };
  [AmplitudeEvents.product_removed_from_favorite]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
    environment?: string;
  };
  [AmplitudeEvents.cart_icon_clicked]: { user_id?: string; environment?: string };
  [AmplitudeEvents.product_added_to_cart]: {
    shop_id: number;
    shop_name: string;
    product_id: string;
    product_name: string;
    branch_id: number | string;
    product_price: number;
    product_quantity: number;
    product_variants?: Array<{
      option_name: string;
      variant_name: string;
    }>;
    status: string;

    environment?: string;
  };

  [AmplitudeEvents.product_added_to_cart_clicked]: {
    shop_id: number;
    shop_name: string;
    product_id: string;
    branch_id: number | string;
    product_name: string;
    product_price: number;
    product_quantity: number;
    product_variants?: Array<{
      option_name: string;
      variant_name: string;
    }>;
  };

  [AmplitudeEvents.product_removed_from_cart]: {
    shop_id: number;
    shop_name: string;
    branchId: string;
    product_id: string;
    item_type_id: number;
    variant_id?: string;
    product_name: string;
    product_price: number;
    product_quantity?: number;
    environment?: string;
  };
  [AmplitudeEvents.product_quantity_increased]: {
    shop_id: number;
    shop_name: string;
    product_id: string;
    cart_id: number;
    item_type_id: number;
    variant_id?: string;
    product_name: string;
    product_price: number;
    product_quantity?: number;
    environment?: string;
  };
  [AmplitudeEvents.product_quantity_decreased]: {
    storeId: number;
    storeName: string;
    productId: string;
    itemTypeId: number;
    variantId?: string;
    productName: string;
    productPrice: number;
    productQuantity?: number;
    environment?: string;
  };
  [AmplitudeEvents.product_picture_clicked]: {
    storeId: number;
    storeName: string;
    branchId: number;
    productId: string;
    productName: string;
    environment?: string;
  };

  // ******************Checkout Screen*************//

  [AmplitudeEvents.checkout_started]: {
    cart_id: number;
    cart_items_count: number;
    product_IDs: number[];
  };

  [AmplitudeEvents.gift_checkout_started]: {
    cart_id: number;
    cart_items_count: number;
    product_IDs: number;
  };

  [AmplitudeEvents.order_type_clicked]: {
    cart_id: number;
    delivery_type: 'instant' | 'scheduled';
  };
  [AmplitudeEvents.address_changed]: {
    cart_id: string;
    cart_items_count: number;
    product_IDs: string[];
    delivery_type: string;
    payment_method_type: string;
    environment?: string;
  };
  [AmplitudeEvents.change_payment_method]: {
    cart_id: number;
    payment_method_type?: string;
  };
  [AmplitudeEvents.use_wallet_balance_clicked]: {
    balanceAmount: string;
    balanceUsed: 'yes' | 'no';
    environment?: string;
  };
  [AmplitudeEvents.apply_coupon_code_clicked]: {
    cart_id: number;
    coupon_code: string;
    coupon_type: string;
    is_valid: 'yes' | 'no';
  };
  [AmplitudeEvents.payment_failed]: {
    cart_id: number;
    paymeny_method: string;
    failure_reason: string;
  };

  [AmplitudeEvents.pay_order_clicked]: {
    cart_id: number;
    cart_items_count: number;
    product_IDs: number[];
  };
  [AmplitudeEvents.order_created]: {
    shop_id: number;
    order_id: number;
    payment_method: number;
    product_IDs: number[];
    delivery_type: string;
  };
  [AmplitudeEvents.order_creation_failed]: {
    order_id: number;
    shop_id: number;
    payment_method: string;
    product_IDs: number[];
    delivery_type: string;
    failure_reason: string;
  };

  [AmplitudeEvents.profile_updated]: {
    userId?: string;
    environment?: string;
  };
  // Page View
  [AmplitudeEvents.page_viewed]: {
    path?: string;
    environment?: string;
  };

  /*************** Order Details ********************* */

  [AmplitudeEvents.order_cancellation_initiated]: {
    order_id: number;
    shop_id: number;
    payment_method: string;
    delivery_type: string;
  };

  [AmplitudeEvents.order_cancelled]: {
    order_id: number;
    shop_id: number;
    payment_method: string;
    delivery_type: string;
    cancel_reason: string;
  };
  [AmplitudeEvents.reorder_initiated]: {
    shop_id: number;
    payment_method: string;
    delivery_type: string;
    original_order_id: number;
    original_order_status: string;
  };
  [AmplitudeEvents.issue_request_initiated]: {
    order_id: number;
    shop_id: number;
    payment_method: string;
    delivery_type: string;
  };
  [AmplitudeEvents.issue_request_submitted]: {
    order_id: number;
    shop_id: number;
    payment_method: string;
    delivery_type: string;
  };
};
